module.exports = __webpack_public_path__ + "img/xyptsc_img.60cde618.png";